function ViewMemberInfo(props) {
  return (
    <div className="col-12">
      <div className="row">
        <div className="col-12 mb-30">
          <h5 className="sub-title">나의 계정정보</h5>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-4 col-md-4 col-sm-12">
          <div className="form-group">
            <label className="form-control-label">아이디</label>
            <input
              name="userid"
              type="text"
              className="form-control"
              maxLength="25"
              value={props.myinfo.userid || ""}
              readOnly={true}
            />
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12">
          <div className="form-group">
            <label className="form-control-label">이름</label>
            <input
              id="username"
              name="username"
              type="text"
              className="form-control"
              maxLength="25"
              value={props.myinfo.username || ""}
              onChange={props.userHandleChange}
            />
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12">
          <div className="form-group">
            <label className="form-control-label">휴대전화번호</label>
            <input
              type="text"
              id="hp"
              name="hp"
              className="form-control"
              maxLength="11"
              data-type="int"
              value={props.myinfo.hp || ""}
              onChange={props.userHandleChange}
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-4 col-md-6 col-sm-12">
          <div className="form-group">
            <label className="form-control-label">현재비밀번호</label>
            <input
              type="password"
              id="passwd"
              name="passwd"
              className="form-control"
              maxLength="20"
              onChange={props.userHandleChange}
            />
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <div className="form-group">
            <label className="form-control-label">비밀번호변경</label>
            <input
              type="password"
              id="new_passwd"
              name="new_passwd"
              className="form-control"
              maxLength="20"
              onChange={props.userHandleChange}
            />
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <div className="form-group">
            <label className="form-control-label">비밀번호변경 확인</label>
            <input
              type="password"
              id="new_re_passwd"
              name="new_re_passwd"
              className="form-control"
              maxLength="20"
              onChange={props.userHandleChange}
            />
          </div>
        </div>
      </div>

      <div className="row pt-20">
        <div className="col-12 text-center">
          <span
            className="btn btn-main btn-icon btn-round-full"
            onClick={props.fnSaveClick}
          >
            저장
          </span>
        </div>
      </div>
    </div>
  );
}

export default ViewMemberInfo;
